/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import { combineReducers } from 'redux';
import viewReducer from './viewReducer';
import modalReducer from './modalReducer';
import notificationReducer from './notificationReducer';
import userReducer from './userReducer';
import cadenceReducer from './cadenceReducer';
import workPackageReducer from './workPackageReducer';
import taskReducer from './taskReducer';
import attachmentReducer from './attachmentReducer';
import criteriaReducer from './criteriaReducer';
import teamReducer from './teamReducer';
import targetReducer from './targetReducer';
import goalReducer from './goalReducer';
import productReducer from './productReducer';
import defaultOptionsReducer from './defaultOptionsReducer';
import organizationReducer from './organizationReducer';
import deploymentReducer from './deploymentReducer';
import listReducer from './listReducer';
import dropDownReducer from './dropDownReducer';
import trashReducer from './trashReducer';
import taskTypeReducer from './taskTypeReducer';
import savedViewReducer from './savedViewReducer';
import tourReducer from './tourReducer';

// keep this list alphabetized please!
const appReducer = combineReducers({
  attachmentReducer,
  cadenceReducer,
  criteriaReducer,
  defaultOptionsReducer,
  deploymentReducer,
  dropDownReducer,
  goalReducer,
  listReducer,
  modalReducer,
  notificationReducer,
  organizationReducer,
  productReducer,
  savedViewReducer,
  targetReducer,
  taskReducer,
  taskTypeReducer,
  teamReducer,
  tourReducer,
  trashReducer,
  userReducer,
  viewReducer,
  workPackageReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    window.localStorage.clear();

    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
